import React, { useEffect } from 'react'
import * as _ from 'lodash'

// @material-ui
import withStyles from '@material-ui/core/styles/withStyles'

// @Components

// @Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// @Assets
import registerStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx'

// @actions
import {
	ValidateEmailToken,
	SendSmsCode,
	ValidateSmsCode,
} from '../../redux/actions'

// @utils
import compose from 'utils/compose'
import { connectRouterState } from 'utils/connectRouterState'

// MOMENT JS
import * as moment from 'moment'
import { withTranslation } from 'react-i18next'
import { useConfirmRegistration } from './hooks'
import Template from './template'

require('moment/locale/pt-br')
moment.locale('pt-br')

const ConfirmRegistration = (props) => {
	const sharedProps = useConfirmRegistration(props)
	const { ValidateEmailToken, getTheme } = sharedProps

	useEffect(() => {
		getTheme()
		if (props.urlState.token) ValidateEmailToken(props.urlState.token)
	}, [])

	return (
		<Template  {...sharedProps} props={props} />
	)
}

const mapStateToProps = (state) => {
	return {
		emailToken: state.users.emailToken,
		emailTokenFailed: state.users.emailTokenFailed,
		smsRequest: state.users.smsRequest,
		smsRequestFailed: state.users.smsRequestFailed,
		putSms: state.users.putSms,
		putSmsFailed: state.users.putSmsFailed,
	}
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{ ValidateEmailToken, SendSmsCode, ValidateSmsCode },
		dispatch,
	)

export default compose(
	connect(mapStateToProps, mapDispatchToProps),
	withStyles(registerStyle),
	withTranslation(),
	connectRouterState({ token: '' }),
)(ConfirmRegistration)
